
export function setItemCategories(props) {
    let itemCategories = [];
    let catNames= [];
    const cat_Names = props.configs.data["disagg101.cat_names"];
    catNames = cat_Names.split(',');
    if (props.translations.data) {  
     for (let j = 0; j < catNames.length; j++) {
      let category = catNames[j];
      let catNameCapital = category.toUpperCase();
      let desc = `DISAGG101_AIC.${catNameCapital}.DESC`;
      let title = `DISAGG101_AIC.${catNameCapital}`;
      let image = `disagg101.cat_${category}`;
      itemCategories.push({
        'image': props.configs.data[image],
        'title': props.translations.data[title],
        'description':props.translations.data[desc]
    });
    }
  }
    return itemCategories;
  };

  export function setGasItemCategories(props) {
    let gasItemCategories = [];
      let gasCatNames= [];
      const gas_Cat_Names = props.configs.data["disagg101.gas_cat_names"];
      gasCatNames = gas_Cat_Names.split(',');
      if (props.translations.data) {  
      for (let j = 0; j < gasCatNames.length; j++) {
        let gascategory = gasCatNames[j];
        let gascatNameCapital = gascategory.toUpperCase();
        let desc = `DISAGG101_AICGAS.${gascatNameCapital}.DESC`;
        let title = `DISAGG101_AICGAS.${gascatNameCapital}`;
        let image = `disagg101.gas_cat_${gascategory}`;
        gasItemCategories.push({
          'image': props.configs.data[image],
          'title': props.translations.data[title],
          'description':props.translations.data[desc]
        });
      }
    }
    return gasItemCategories;
  };

  export function setItemQuestionnaire(props) {
    let itemQuestionnaire = [];
    const quescount = props.configs.data["disagg101.questions"]
    if (props.translations.data) {  
      for (let j = 0; j < quescount; j++) {
       let question = `DISAGG101_AIE.QUESTION_${j + 1}`;
       let answer = `DISAGG101_AIE.ANSWER_${j + 1}`;
        itemQuestionnaire.push({
          'question': props.translations.data[question],
          'answer': props.translations.data[answer],
      });
    }
  }
    return itemQuestionnaire ;
  };

  export function setItemAlerts(props) {
    let itemAlerts = [];
    const quescount = props.configs.data["disagg101.alertquestions"]
    if (props.translations.data) {  
      for (let j = 0; j < quescount; j++) {
        let question = `DISAGG101_PO.QUESTION_${j + 1}`;
        let answer = `DISAGG101_PO.ANSWER_${j + 1}`;
        itemAlerts.push({
        'question': props.translations.data[question],
        'answer': props.translations.data[answer],
      });
    }
  }
    return itemAlerts ;
  };

  export function setItemHer(props) {
    let itemHer = [];
    const quescount = props.configs.data["disagg101.herquestions"]
    if (props.translations.data) {  
       for (let j = 0; j < quescount; j++) {
          let question = `DISAGG101_HER.QUESTION_${j + 1}`;
          let answer = `DISAGG101_HER.ANSWER_${j + 1}`;
          itemHer.push({
          'question': props.translations.data[question],
          'answer': props.translations.data[answer],
        });
      }
    }
    return itemHer;
  };
